<script setup>
import { ref, computed } from 'vue';
import Input from 'dashboard/components-next/input/Input.vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: 'i-lucide-activity',
  },
});

const emit = defineEmits(['update:modelValue']);

const searchQuery = ref('');

const commonIcons = [
  'i-lucide-activity',
  'i-lucide-alert-circle',
  'i-lucide-arrow-right',
  'i-lucide-bar-chart',
  'i-lucide-box',
  'i-lucide-building',
  'i-lucide-calendar',
  'i-lucide-check-circle',
  'i-lucide-clock',
  'i-lucide-database',
  'i-lucide-edit',
  'i-lucide-euro',
  'i-lucide-external-link',
  'i-lucide-file',
  'i-lucide-folder',
  'i-lucide-globe',
  'i-lucide-hard-drive',
  'i-lucide-home',
  'i-lucide-image',
  'i-lucide-info',
  'i-lucide-layout-grid',
  'i-lucide-link',
  'i-lucide-list',
  'i-lucide-loader',
  'i-lucide-mailbox',
  'i-lucide-map',
  'i-lucide-map-pin',
  'i-lucide-message-circle',
  'i-lucide-message-square',
  'i-lucide-package',
  'i-lucide-plus',
  'i-lucide-refresh-cw',
  'i-lucide-search',
  'i-lucide-settings',
  'i-lucide-shopping-cart',
  'i-lucide-star',
  'i-lucide-tag',
  'i-lucide-trash-2',
  'i-lucide-truck',
  'i-lucide-user',
  'i-lucide-users',
  'i-lucide-zap',
  'i-lucide-smartphone',
  'i-lucide-mail',
  'i-lucide-phone',
  'i-lucide-share-2',
  'i-lucide-download',
  'i-lucide-eye',
];

const filteredIcons = computed(() => {
  if (!searchQuery.value) return commonIcons;
  const q = searchQuery.value.toLowerCase();
  return commonIcons.filter(icon => icon.toLowerCase().includes(q));
});

const selectIcon = icon => {
  emit('update:modelValue', icon);
};
</script>

<template>
  <div class="space-y-3">
    <div class="flex items-center gap-3 mb-2">
      <div
        class="p-3 rounded-xl bg-n-brand/10 border border-n-brand/20 shadow-sm shrink-0"
      >
        <span class="size-6 text-n-brand" :class="[modelValue]" />
      </div>
      <div class="flex-1">
        <Input
          v-model="searchQuery"
          placeholder="Rechercher une icône..."
          size="sm"
          class="shadow-sm"
        />
      </div>
    </div>

    <div
      class="grid grid-cols-6 gap-2 p-3 rounded-xl bg-n-alpha-1 border border-n-weak max-h-[200px] overflow-y-auto custom-scrollbar"
    >
      <button
        v-for="icon in filteredIcons"
        :key="icon"
        class="p-2.5 rounded-lg flex items-center justify-center transition-all border border-transparent"
        :class="
          modelValue === icon
            ? 'bg-n-brand text-white shadow-brand-sm scale-110 z-10'
            : 'bg-n-solid-1 text-n-slate-10 hover:bg-n-alpha-2 hover:text-n-brand hover:border-n-brand/20'
        "
        :title="icon"
        @click="selectIcon(icon)"
      >
        <span class="size-5" :class="[icon]" />
      </button>
      <div
        v-if="filteredIcons.length === 0"
        class="col-span-6 py-8 text-center text-xs text-n-slate-10 uppercase tracking-widest font-bold"
      >
        Aucune icône trouvée
      </div>
    </div>
  </div>
</template>
